// extracted by mini-css-extract-plugin
export default {"main_container":"style_main_container__EhqgL","subtitle":"style_subtitle__7LxU9","button":"style_button__r+o1b"};